const BASE_RECENT_NOTES_KEY = 'closot_recent_notes';

// null rather than an unscoped key: a shared bucket is readable from every
// workspace, so one write with no workspace leaks the page into all of them.
function getRecentNotesKey(workspaceId?: string): string | null {
  return workspaceId ? `${BASE_RECENT_NOTES_KEY}_${workspaceId}` : null;
}

/**
 * Retrieves the list of recent note IDs from localStorage for the given workspace.
 */
export function getRecentNoteIds(workspaceId?: string): string[] {
  if (typeof window === 'undefined') return [];
  const key = getRecentNotesKey(workspaceId);
  if (!key) return [];
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error('Failed to parse recent notes', e);
    return [];
  }
}

/**
 * Adds a note ID to the recent list for the given workspace (no reorder if already present, limits to 10).
 * Dispatches a custom event 'recentNotesChanged' for UI reactivity.
 */
export function addRecentNoteId(id: string, workspaceId?: string) {
  if (typeof window === 'undefined' || !id) return;
  const key = getRecentNotesKey(workspaceId);
  if (!key) return;

  const currentIds = getRecentNoteIds(workspaceId);
  if (currentIds.includes(id)) return;
  const updatedIds = [id, ...currentIds].slice(0, 10);

  localStorage.setItem(key, JSON.stringify(updatedIds));
  window.dispatchEvent(new CustomEvent('recentNotesChanged'));
}

export function removeRecentNoteId(id: string, workspaceId?: string) {
  if (typeof window === 'undefined' || !id) return;
  const key = getRecentNotesKey(workspaceId);
  if (!key) return;

  const currentIds = getRecentNoteIds(workspaceId);
  const updatedIds = currentIds.filter(existingId => existingId !== id);

  localStorage.setItem(key, JSON.stringify(updatedIds));
  window.dispatchEvent(new CustomEvent('recentNotesChanged'));
}
